import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PageDescription = makeShortcode("PageDescription");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ResourceCard = makeShortcode("ResourceCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Hier findest du Github Repositories, Design Tools und Storybooks`}</p>
    </PageDescription>
    <h2>{`Github Repos`}</h2>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="Cranach Design" actionIcon="launch" aspectRatio="2:1" href="https://github.com/cranach-design-system/cranach-design" mdxType="ResourceCard">
  </ResourceCard>
      </Column>
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="Cranach Design React Pattern" actionIcon="launch" aspectRatio="2:1" href="https://github.com/cranach-design-system/cranach-design/tree/main/packages/react-pattern" mdxType="ResourceCard">
  </ResourceCard>
      </Column>
    </Row>
    <h2>{`Storybooks`}</h2>
    <Row className="resource-card-group" mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
  <ResourceCard subTitle="Cranach Design React Pattern Storybook" actionIcon="launch" aspectRatio="2:1" href="https://storybook-cranachdesign.netlify.app" mdxType="ResourceCard">
  </ResourceCard>
      </Column>
    </Row>
    <h2>{`Tools`}</h2>
    <p>{`Tools folgen…`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      